import { createFileRoute } from '@tanstack/react-router'
import { EditProjectPage } from '@/features/projects/pages/edit-project-page'

export const Route = createFileRoute('/_authenticated/_sidebar/grower/projects/$projectId/edit')({
	component: EditProject,
})

function EditProject() {
	const { projectId } = Route.useParams()
	return <EditProjectPage projectId={projectId} />
}
